<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="getEmails()">Gestione Emails</a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1"><Translate :path="'dizionario.base.ELENCO'"></Translate> Template Emails</span>
				</h4>
				<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
			</div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">

					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 position-10" style="text-align: left;" v-if="$root.hasFunzionalita('EMAIL_CREATE')" v-on:click="nuovaEmail()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0">
								<div><Translate :path="'dizionario.base.BTN_NUOVA'"></Translate> Email</div>
							</div>
							<div class="text-success fw-semibold"><Translate :path="'dizionario.base.BTN_ADD'"></Translate></div>
						</div>
					</a>

					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a v-if="$root.hasFunzionalita('CONF_GENERALI_READ')" href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill" v-on:click="$root.confTravelTipologiche()" title="Opzioni Utenti" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-lightning"></i>
						</a>
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.confTravelLingue()" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help()" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#emails-a" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded" data-bs-toggle="tab" aria-selected="true" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list"></i>
								<span class="hidden-lg ms-1">Emails</span>
								<span class="hidden-xs ms-1"><Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate>Emails</span>
							</div>
						</a>
					</li>
					<li class="nav-item d-lg-none ms-auto">
						<a href="#profile_nav" class="navbar-nav-link navbar-nav-link-icon rounded-pill rounded-pill-small collapsed" data-bs-toggle="collapse" aria-expanded="false">
							<i class="ph-caret-down collapsible-indicator"></i>
						</a>
					</li>
				</ul>

				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1">
							<div class="btn-group">
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
									<i class="ph-gear me-1"></i>
									<span style="font-size:0.8rem;">Azioni Multiple</span>
								</a>
								<div class="dropdown-menu dropdown-menu-end" style="">
									<div class="dropdown-submenu dropdown-submenu-start" v-if="$root.hasFunzionalita('EMAIL_UPDATE')">
										<a href="#" class="dropdown-item"><i class="far fa-ballot-check fa-fw me-2"></i><span class="text-muted me-1">|</span>Stato</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" @click.prevent="attivaSelezionati()"><i class="far fa-check-square fa-fw me-2"></i>Attiva selezionati</a>
											<a href="#" class="dropdown-item" @click.prevent="disattivaSelezionati()"><i class="far fa-square fa-fw me-2"></i>Disattiva selezionati</a>
										</div>
									</div>
									<div class="dropdown-divider"></div>
									<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('EMAIL_DELETE')" @click.prevent="eliminaSelezionati()"><i class="far fa-trash fa-fw me-2 text-danger"></i><span class="text-muted me-1">|</span>Elimina selezionati</a>
								</div>
							</div>
						</li>
						<li class="nav-item">

						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- /profile navigation -->	

	</div>
	<!-- /page header -->

	<!-- Content area -->
    <div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1">

			<div class="tab-pane fade active show" id="utenti-a">
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>
					<div class="collapse" :class="{ show: !$root.isMobile }" id="collapse-all" style="">				
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="utente-a">
                                    <div class="row">
                                        <div class="col-4 col-md-2 form-group2">
                                            <input class="form-control form-control-sm" autocomplete="off" placeholder="Descrizione" type="text" v-model="search.DESCRIZIONE.VALUE">
                                        </div>           
                                        <div class="col-8 col-md-8 form-group2">
                                        </div>          
                                        <div class="col-8 col-md-2 form-group2">
			                                <a href="#collapse-a" class="btn btn-flat-info btn-sm w-100 collapsed" data-bs-toggle="collapse" v-on:click="filters.resizeGrid('collapse-a','tableFixHead','box-card')" role="button" aria-expanded="false">
												&nbsp;
											</a>
                                        </div>
                                    </div>
								</form>
							</div>
						</div>
					</div>
				
			        <div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead" style="min-height: calc(100vh - 392px);">
		               		<table class="table table-bordered table-hover table-striped table-togglable table-width"> 
			                    <thead class="sticky-top">
                                    <tr class="bg-secondary text-white">
                                        <th class="table-head-sm" style="width:2%;"> <input id="chkAllUsers" v-on:click="filters.selectAll('chkAllUsers',paginatedList.arr)" type="checkbox" class=""> </th>
										<th class="table-head-sm" style="width:6%;"> # <ISort class="float-end" v-model="ordinamento" :campo="'DESCRIZIONE'"></ISort><br /><span class="float-end">Ord. </span></th>
										<th class="table-head-sm text-center" style="width:4%;"> Img </th>
										<th class="table-head-sm" style="width:30%;">Titolo</th>
                                        <th class="table-head-sm">Descrizione</th>
										<th class="table-head-sm text-center" style="width:5%;">Stato</th>
										<th class="table-head-sm text-center" style="width:5%;">Azioni</th>
                                    </tr>
                                </thead>
								<tbody>
									<tr v-for="item in paginatedList.arr" v-bind:key="item.ID_TESTO_EMAIL">
										<td class="td-class text-center">
											<span class="footable-toggle"></span>
											<input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="item.SELEZIONATO" class=""> 
										</td>
										<td class="td-class">
											{{item.ID_TESTO_EMAIL}}<br />
											<small class="badge bg-light badge-xs text-primary cursor-pointer float-end"> &nbsp; </small>
										</td>
										<td class="td-class text-center">
											<a href="#" @click.prevent="anteprimaEmail(item)" title="Anteprima Email">
												<i class="ph-eye text-primary"></i>
											</a>
										</td>
										<td class="td-class fs-sm">
											<span class="text-primary text-uppercase fw-bold cursor-pointer">{{item.OGGETTO}}</span>
											<br>
											<span class="text-muted">&nbsp;</span>
										</td>
										<td class="td-class fs-sm">
											{{item.DESCRIZIONE}}
										</td>
										<td class="td-class">

										</td>
										<td class="td-class text-center">
											<div class="dropdown">
												<a href="#" class="text-body" data-bs-toggle="dropdown" aria-expanded="false">
													<i class="ph-list"></i>
												</a>
												<div class="dropdown-menu dropdown-menu-end">
													<div class="dropdown-header text-uppercase font-size-xs line-height-xs">Gestione</div>
													<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('EMAIL_UPDATE')" v-on:click="modificaEmail(item)"><i class="fal fa-pencil fa-fw"></i> Modifica</a>
													<div class="dropdown-divider"></div>
													<a href="#" class="dropdown-item" v-on:click="testEmail(item)"><i class="fal fa-envelope fa-fw"></i> Test email</a>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
		
		                <div class="row page-bottom">
							<div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
                                <div style="position: relative; top: 10px;">
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2"><span>CLIENTI</span>: </span> 
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 ms-2">FATTURATO: </span>
                                </div>
                            </div>
							<div class="col-9 col-md-6" :tabindex="27">
		                        <div class="float-end pag-mobile">
			                        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
			                    </div>
			                </div>
							<div class="col-3 col-md-1" :tabindex="28">
								<select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="search.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
		                            <option value="5">5</option>
		                            <option value="10">10</option>
		                            <option value="25">25</option>
		                            <option value="50">50</option>
		                            <option value="75">75</option>
		                            <option value="100">100</option>
		                            <option value="250">250</option>
		                            <option value="500">500</option>
		                        </select>
			            	</div>
			        	</div>
					</div>
				</div>
			</div>

		</div>
	</div>	


	<!-- START MODALI -->
	<div class="modal fade" id="popUpAnteprimaEmail" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white border-0">
					<h5 class="modal-title">
						<i class="ph-envelope me-2"></i><span class="me-2">Anteprima Email</span>
					</h5>
                    <button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
				</div>
				<div class="modal-body p-2" style="height: 33rem;">

                    <div class="card card-noshadow mb-0">
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-12">
									<strong>Oggetto:</strong> {{ anteprimaEmailData.OGGETTO }}
								</div> 
							</div>
                            <div class="row">
                                <div class="col-12">
									<iframe ref="anteprimaIframe" style="width:100%;min-height:400px;border:1px solid #ddd;border-radius:0.25rem;background:#fff;"></iframe>
								</div> 
							</div>
						</div>
					</div>

				</div>
				<div class="modal-footer bg-light p-1">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
                        <i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
                    </button>
				</div>
			</div>
		</div>
	</div>

	<div class="modal fade" id="popUpTestoEmail" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white border-0">
					<h5 class="modal-title">
						<i class="ph-envelope me-2"></i><span class="me-2">Email</span>
					</h5>
                    <button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
				</div>
				<div class="modal-body p-2" style="height: 40rem;">

					<div class="card card-noshadow mb-0">
                        <div class="card-body">
                            <div class="row mb-2">
								<div class="col-md-6">
									<label class="form-label text-danger mb-1">Oggetto</label>
									<input type="text" class="form-control" v-model="emailSelezionata.OGGETTO">
								</div>
								<div class="col-md-6">
									<label class="form-label text-danger mb-1">Descrizione</label>
									<input type="text" class="form-control" v-model="emailSelezionata.DESCRIZIONE">
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<label class="form-label text-danger mb-1">Messaggio</label>
									<ckeditor :editor="editor" v-model="emailSelezionata.TESTO" :config="editorConfig"></ckeditor>
								</div>
							</div>
						</div>
					</div>

				</div>
				<div class="modal-footer bg-light p-1">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
                        <i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
                    </button>
					<button type="button" class="btn btn-success" v-on:click="salvaEmail()"><i class="fa fa-check fa-fw"></i> Salva</button>
				</div>
			</div>
		</div>
	</div>

	<div class="modal fade" id="popUpEmail" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white border-0">
					<h5 class="modal-title">
						Modifica avatar
					</h5>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
				</div>
				<div class="modal-body p-2" style="height: 25rem;">

					<div class="col-md-12">
						<label class="form-label text-danger mb-1">Indirizzo email</label>
						<input type="text"  class="form-control" v-model="emailTest">
					</div>

				</div>
				<div class="modal-footer bg-light p-1">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
                        <i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
                    </button>					
					<button type="button" class="btn btn-success" v-on:click="doTestEmail()"><i class="fa fa-check fa-fw"></i> Invia</button>
				</div>
			</div>
		</div>
	</div>

</template>



<script>

import Pagine from '@/components/utils/Pagine.vue'
import ISort from '@/components/utils/ISort.vue'
import ClassicEditor from '@/utils/CustomCKEditor'


export default {
    name:"Emails",

    components:{
        Pagine,
		ISort,
		
    },

    data:function(){
        return {
            apiStartup:'core/testiemail',
            filters:global.filters,
            GLOBAL_IMAGES_PATH:'',
			anno:new Date().getFullYear(),
            arrayEmails:new Array(),
            emailSelezionata:{},
            anteprimaEmailData:{},
            emailTest:'',
            editor: ClassicEditor,
            editorConfig: {
                height: 400,
            },
            search:{
	            PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
				DESCRIZIONE:{TYPE:'TEXT',VALUE:''},
	        },
		    ordinamento:'',

        }
    },

    methods:{

        getEmails: function () {
            utils.get(this.apiStartup,{}, (response) => {
                this.arrayEmails = response.data;
            });
        },

        anteprimaEmail: function(item){
            this.anteprimaEmailData = utils.clone(item);
            this.filters.openPopUp('popUpAnteprimaEmail');
            this.$nextTick(() => {
                const iframe = this.$refs.anteprimaIframe;
                if (iframe) {
                    const blob = new Blob([item.TESTO], { type: 'text/html' });
                    iframe.src = URL.createObjectURL(blob);
                }
            });
        },

        nuovaEmail: function(){
            this.emailSelezionata = utils.nuovoElemento(this.emailSelezionata,{ID_TESTO_EMAIL:0,className:"TestoEmail"},"popUpTestoEmail");
        },

        modificaEmail: function(item){
            item.className = "TestoEmail";
            this.emailSelezionata = utils.modificaElemento(this.emailSelezionata,item,"popUpTestoEmail");
        },

        salvaEmail: function(){
            utils.salvaElemento("core/basic/",this.emailSelezionata,"ID_TESTO_EMAIL","popUpTestoEmail",(response) => {
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                    this.getEmails();
                }
            });
        },

        testEmail : function(item){
            this.emailSelezionata = item;
            this.filters.openPopUp('popUpEmail');
        },

        doTestEmail : function(){
            this.filters.closePopUp('popUpEmail');
            utils.post("core/testiemail/test",{ID_TESTO_EMAIL:this.emailSelezionata.ID_TESTO_EMAIL,DESTINATARIO:this.emailTest}, (response) => {
                if(response.esito == 0){
					utils.alert.success('Email Inviata con successo');
				}else{
					utils.alert.warning("Errore nell'invio della mail");
				}
            });
        },

       

		


    },

    computed: {
		paginatedList(){
            var arr = utils.inGrid(this.arrayEmails,this.search,this.ordinamento);
            return arr;
        },	 


       
    },
	
	watch:{
	
	},

    created : function(){
        global.utils.BASE_API = process.env.VUE_APP_API_URL;
        this.GLOBAL_IMAGES_PATH = process.env.VUE_APP_GLOBAL_IMAGES_PATH;
		this.getEmails();
        
    }

}
</script>
